const gztjjz = [{
  path: 'gztj_zzjg',
  name: 'gztj_zzjg',
  component: () =>
        import('@/components/gztjjz/zzjg/index'),
  meta: { title: '组织机构', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_gzjh',
  name: 'gztj_gzjh',
  component: () =>
        import('@/components/gztjjz/gzfa/gzjh'),
  meta: { title: '工作计划', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_gzjhdb',
  name: 'gztj_gzjhdb',
  component: () =>
        import('@/components/gztjjz/gzfa/gzjhdb'),
  meta: { title: '工作计划督办', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_gzfawc',
  name: 'gztj_gzfawc',
  component: () =>
        import('@/components/gztjjz/gzfa/gzfawc'),
  meta: { title: '工作方案完成', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_gzfajl',
  name: 'gztj_gzfajl',
  component: () =>
        import('@/components/gztjjz/gzfa/gzfajl'),
  meta: { title: '工作方案记录', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_pxjy',
  name: 'gztj_pxjy',
  component: () =>
        import('@/components/gztjjz/pxjy/pxjy'),
  meta: { title: '培训教育', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_pxjydb',
  name: 'gztj_pxjydb',
  component: () =>
        import('@/components/gztjjz/pxjy/pxjydb'),
  meta: { title: '培训教育督办', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_pxjyxx',
  name: 'gztj_pxjyxx',
  component: () =>
        import('@/components/gztjjz/pxjy/pxjyxx'),
  meta: { title: '培训教育完成', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_pxjyjl',
  name: 'gztj_pxjyjl',
  component: () =>
        import('@/components/gztjjz/pxjy/pxjyjl'),
  meta: { title: '培训教育记录', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_glzd',
  name: 'gztj_glzd',
  component: () =>
        import('@/components/gztjjz/glzd/glzd'),
  meta: { title: '管理制度', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_glzddb',
  name: 'gztj_glzddb',
  component: () =>
        import('@/components/gztjjz/glzd/glzddb'),
  meta: { title: '管理制度督办', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_glzdxx',
  name: 'gztj_glzdxx',
  component: () =>
        import('@/components/gztjjz/glzd/glzdxx'),
  meta: { title: '管理制度完成', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gztj_glzdjl',
  name: 'gztj_glzdjl',
  component: () =>
        import('@/components/gztjjz/glzd/glzdjl'),
  meta: { title: '管理制度记录', requireAuth: true, keepAlive: true, permission: true }
} ]
export default gztjjz



// WEBPACK FOOTER //
// ./src/router/gztjjz.js